import React from "react";
import {Button, Checkbox, Col, Modal, Row} from "antd";
import {connect} from "react-redux";
import {loadTermsOfService, updateTermsOfService} from "../../actions/account";
import {displayErrors} from "../../libs/utils";
import {Link} from "react-router-dom";

class TermsOfServiceModal extends React.Component {
    state = {
        loading: true,
        showModal: true,
        termsOfService: null,
        agreedTerms: false,
        scrolledToBottom: false,
        saving: false,
    }

    componentDidMount() {
        this.props.loadTermsOfService((res) => {
            this.setState({ loading: false, termsOfService: res.data.terms_of_service });
        }, (err) => {
            if(typeof err.response!== 'undefined') {
                displayErrors(err.response.data);
            }
            this.setState({ loading: false });
        })
    }

    agreeToTerms() {
        this.props.updateTermsOfService(() => {
            window.location.reload();
            this.setState({ saving: false });
        }, (err) => {
            if(typeof err.response!== 'undefined') {
                displayErrors(err.response.data);
            }

            this.setState({ saving: false });
        })
    }

    handleScroll = e => {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        const reachedBottom = scrollTop + clientHeight >= scrollHeight - 5;

        if (reachedBottom && !this.state.scrolledToBottom) {
            this.setState({ scrolledToBottom: true });
        }
    };

    render() {
        return <Modal
            open={this.state.showModal} title='Updated Terms of Service' width='700px'
            footer={<Row justify='space-between'>
                <Col>
                    <Link to='/auth/logout'><Button>Log Out</Button></Link>
                </Col>
                <Col>
                    <Button type='primary' loading={this.state.saving} onClick={() => this.agreeToTerms()} disabled={!this.state.agreedTerms || this.state.saving}>Agree and Continue</Button>
                </Col>
            </Row>}
            closable={false} centered>
            <p>We have updated our Terms of Service. To continue using your Priority Prospect account and Services, you must review and agree to the updated Terms of Service. <a href='https://priorityprospect.com/legal/terms-of-service/' target='_blank' rel='noopener noreferrer'><b>View full Terms of Service in a new tab</b></a>.</p>
            <p>If you do not agree to the Terms of Service, access to the Services will be restricted. You may log out or contact our support team to request account closure or assistance.</p>
            <div style={{height: '400px', overflowX: 'auto', border: '1px solid #ccc', padding: '10px'}}
                 dangerouslySetInnerHTML={{__html: this.state.termsOfService}} onScroll={this.handleScroll} />
            <div>
                <Checkbox disabled={!this.state.scrolledToBottom} onChange={(e) => this.setState({ agreedTerms: e.target.checked }) }>
                    I hereby acknowledge that I have read, understand, and agree to be legally bound by Priority Prospect OÜ's Terms of Service.
                </Checkbox>
            </div>

        </Modal>;
    }
}

export default connect(null, { loadTermsOfService, updateTermsOfService })(TermsOfServiceModal);